import { gu_isAppLayoutProMax } from '@utils/general-util';

import { getCurrencyFromSelectedLanguage } from '../../util/language-util';
import { languageConstants } from '../constant/language.constant';

export const languageAction = {
    changeLanguage,
};

function changeLanguage(languageObj) {
    return (dispatch) => {
        const { countryLanguageKey } = languageObj;
        const lengthLanguage = countryLanguageKey.length;
        const country = countryLanguageKey.substring(lengthLanguage - 2, lengthLanguage);

        if (window.appLayoutPro || gu_isAppLayoutProMax()) {
            const res = getCurrencyFromSelectedLanguage(countryLanguageKey);
            languageObj.country = country;
            languageObj.countryName = res.countryName;
            languageObj.countryEnglishName = res.countryEnglishName;
            languageObj.currencyLang = res.currency;
            languageObj.src = res.src;
            languageObj.display = res.display;
            dispatch({ type: languageConstants.SET_LANGUAGE, payload: languageObj });
        } else {
            setTimeout(() => {
                if (window.SPL_Content) {
                    clearInterval(this);
                    window.SPL_Content.getCurrencyFromSelectedLanguage(countryLanguageKey).then((res) => {
                        languageObj.country = country;
                        languageObj.countryName = res.countryName;
                        languageObj.currencyLang = res.currency;
                        languageObj.src = res.src;
                        languageObj.display = res.display;
                        dispatch({ type: languageConstants.SET_LANGUAGE, payload: languageObj });
                    });
                }
            }, 10);
        }
    };
}
